var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0033 15.3114C29.0033 14.1603 28.908 13.3203 28.7018 12.4492H15.2891V17.6447H23.162C23.0033 18.9359 22.1462 20.8803 20.2414 22.1869L20.2147 22.3609L24.4555 25.5805L24.7494 25.6092C27.4477 23.167 29.0033 19.5736 29.0033 15.3114Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2853 28.9998C19.1424 28.9998 22.3804 27.7553 24.7456 25.6086L20.2377 22.1863C19.0313 23.0108 17.4123 23.5863 15.2853 23.5863C11.5076 23.5863 8.30128 21.1441 7.15832 17.7686L6.99078 17.7825L2.58111 21.127L2.52344 21.2841C4.87261 25.8574 9.698 28.9998 15.2853 28.9998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15866 17.769C6.85708 16.8979 6.68255 15.9645 6.68255 15.0001C6.68255 14.0356 6.85708 13.1023 7.1428 12.2312L7.13481 12.0456L2.66986 8.64746L2.52377 8.71556C1.55556 10.6134 1 12.7445 1 15.0001C1 17.2556 1.55556 19.3867 2.52377 21.2845L7.15866 17.769Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2854 6.4133C17.9679 6.4133 19.7774 7.54885 20.8092 8.4978L24.8409 4.64C22.3648 2.38445 19.1425 1 15.2854 1C9.69804 1 4.87262 4.1422 2.52344 8.71549L7.14247 12.2311C8.30131 8.85555 11.5076 6.4133 15.2854 6.4133Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.aa616cec414be2a6291f57f053361866.svg";
export { ForwardRef as ReactComponent };